const dbRequest           = require('../../../../../js-network/db-request')
const multitable          = require('../../../../../components/multitable/multitable')
const snack               = require ('../../../../../components/snack/snack')
const snackprovidercredit = require('./providercredit-snack')
const textfieldHandler    = require ('../../../../../components/textfield/textfield-handler')
const autocomplete        = require ('../../../../../components/textfield/autocomplete')

export function getAllPurchaseCredited(detail, htmlFc) {  //console.log('updateCsutomerField -> ', htmlFc)

  let input_provider = htmlFc.fullcontHTML.querySelector("#providercredit_form_provider_id");
  let input_selected = input_provider.getAttribute("selected");


  if (JSON.parse(input_selected).length > 0) {

    load(detail, JSON.parse(input_selected)[0], htmlFc)

  }
}

const load = (detail, value, htmlFc) => {


  return loadDB(detail, value)
    .then((result) => {



      //the entity was deleted
      if (result.multiTables[0] == "") {
        snackprovidercredit.start({ act: 'show', id: 'noCreditedPurchase', });
        multitable.start({ act: 'clean', entityMT: htmlFc.entityMT })
        return
      }/**/

      if (result.multiTables[1] == "") {
        snackprovidercredit.start({ act: 'show', id: 'noPurchasePending', });
        multitable.start({ act: 'clean', entityMT: htmlFc.entityMT })
        return
      }/**/

      // console.log(JSON.parse(result.multiTables[0]));
      // return;

      multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: JSON.parse(result.multiTables[0]) })
      multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: JSON.parse(result.multiTables[1]) })

      multitable.start({ act: 'generator_insert', entityMT: htmlFc.entityMT })


    }).catch((error) => {

      throw error;
      //console.log('Error Getting Purchase', error)

    })
}/**/

async function loadDB(detail, value) {


  detail.inf = { provider_id: value }



  ///yeison/php/settings.php
  //const result = await dbRequest.start(detail, 'php/settings.php' ) //do the insert
  const result = await dbRequest.start(detail, 'server/php/sql/getAllPurchaseCredited.php') //do the insert

  if (result.status != "ok") { throw (result) }

  return result
}

//validar antes de proceder a guardar o actualizar
export function validated(detail, htmlFc) {

  let provider          = htmlFc.fullcontHTML.querySelector("#providercredit_form_provider_id");
  let provider_selected = provider.getAttribute("selected");
  //verificar si se selecciono un provider
  if (JSON.parse(provider_selected).length == 0) {
    textfieldHandler.error(provider);
    snack.start({ act: 'show', id: 'inputErrors'});
    return false;
  }else{
    textfieldHandler.errorClean(provider);
  }


  let InputsError = [];
  let InputsErrorForCheck = [];
  let allInputsEmpty = true;
  // buscar las lineas del mt  Credited Purchase
  let linesCreditedPurchase     = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_credited_purchase .line");
  for (let index = 0; index < linesCreditedPurchase.length; index++) {
    let line = linesCreditedPurchase[index];
    let inputAddCreditedAmount = line.querySelector('.add_credited_amount input');
    let inputUsedCredit = line.querySelector('.used_credit input');
    let UsedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                          parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
    
    if (inputAddCreditedAmount.checked) {
      if (UsedCredit == 0) {
        //guardar en el arreglo los input used credit que tenga el valor 0 y que el input del tipo checkbox de la misma linea este marcado
        InputsError.push(inputUsedCredit);
      }else{
        //significa que hay lineas llenas y marcadas
        allInputsEmpty = false;
        if(!verifyValueCredited(inputUsedCredit,htmlFc)){
          return false;
        }
      }
    }else{
      if (UsedCredit > 0) {
        //guardar en el arreglo los input used credit que tenga el valor  diferente a 0 
        //y que el input del tipo checkbox de la misma linea no este marcado
        InputsErrorForCheck.push(inputUsedCredit);
      }
    }

  }

  //validar que por lo menos se tenga un campo correctamente lleno en el mt Credited Purchases
  if (allInputsEmpty) {
    let linesEmpty  = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_credited_purchase .line .used_credit");
    linesEmpty.forEach(textfield => {
      textfieldHandler.error(textfield);
    });
    snackprovidercredit.start({ act: 'show', id: 'fillAtLeastOneField'});
    return false;
  }

  allInputsEmpty = true;
  // buscar las lineas del mt Unpaid Purchases
  let linesPaidPurchase  = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_paid_purchase .line");
  for (let index = 0; index < linesPaidPurchase.length; index++) {
    let line = linesPaidPurchase[index];
    let inputAddAmount  = line.querySelector('.add_amount input');
    let inputSentAmount = line.querySelector('.sent_amount input');
    let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                          parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);
    
    if (inputAddAmount.checked) {
      if (SentAmount == 0) {
        //guardar en el arreglo los input used credit que tenga el valor 0 y que el input del tipo checkbox de la misma linea este check
        InputsError.push(inputSentAmount);
      }else{
        //significa que hay lineas llenas y marcadas
        allInputsEmpty = false;
        if (!verifyValueSent(inputSentAmount, htmlFc)) {
          return false;
        } 
      }
    }else{
      if (SentAmount > 0) {
        //guardar en el arreglo los input used credit que tenga el valor  diferente a 0 
        //y que el input del tipo checkbox de la misma linea no este marcado
        InputsErrorForCheck.push(inputSentAmount);
      }
    }


  }

  //validar que por lo menos se tenga un campo correctamente lleno en el mt Unpaid Purchases
  if (allInputsEmpty) {
    let linesEmpty  = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_paid_purchase .line .sent_amount");
    linesEmpty.forEach(textfield => {
      textfieldHandler.error(textfield);
    });
    snackprovidercredit.start({ act: 'show', id: 'fillAtLeastOneField'});
    return false;
  }

  

  if (InputsError.length > 0) {
    snackprovidercredit.start({ act: 'show', id: 'fillLineChecked'});
    InputsError.forEach(input => {
      textfieldHandler.error(input.closest(".textfield"));
    });
    return false;
  }

  if (InputsErrorForCheck.length > 0) {
    snackprovidercredit.start({ act: 'show', id: 'fillLineChecked'});
    InputsErrorForCheck.forEach(input => {
      textfieldHandler.error(input.closest(".textfield"));
    });
    return false;

  }

  if (getTotalCreditedToUse(htmlFc) > getTotalSentAmount(htmlFc)) {
    
    for (let index = 0; index < linesCreditedPurchase.length; index++) {
      let line = linesCreditedPurchase[index];
      let inputAddCreditedAmount = line.querySelector('.add_credited_amount input');

      if (inputAddCreditedAmount.checked) {
        let textfieldUsedCredit = line.querySelector('.used_credit');
        textfieldHandler.error(textfieldUsedCredit);
      }
    }

    snackprovidercredit.start({ act: 'show', id: 'greaterAmount'});
    return false;
  }


  //remover las lineas que no se van a guardar
  linesCreditedPurchase.forEach(function (line) {
    let inputUsedCredit = line.querySelector('.used_credit input');
    let UsedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                          parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
    
    if (UsedCredit == 0) {
      line.remove();
    }
  });

  //remover las lineas que no se van a guardar
  linesPaidPurchase.forEach(function (line) {
    let inputSentAmount = line.querySelector('.sent_amount input');
    let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                          parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);
    
    if (SentAmount == 0) {
      line.remove();
    }
  });

  return true;
}

export function keyValueCredited(detail, htmlFc) {
  verifyValueCredited(detail.ev.target, htmlFc);
}


//validar el valor digitado en las purchase con credito
function verifyValueCredited(input, htmlFc) {
  let inputUsedCredit      =  input;
  let UsedCredit           = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                              parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);

  if (UsedCredit != 0) {
    let inputAvailableCredit = inputUsedCredit.closest('.line').querySelector('.available_credit input');
    let availableCredit      = (inputAvailableCredit.value   == "" || parseFloat(inputAvailableCredit.value)   == NaN || 
                                parseFloat(inputAvailableCredit.value)   == 0) ? 0 : parseFloat(inputAvailableCredit.value);

    if (UsedCredit > availableCredit) {
      snackprovidercredit.start({ act: 'show', id: 'greaterUsedCredit'});
      textfieldHandler.error(inputUsedCredit.closest(".textfield"));
      return false;
    } else {
      textfieldHandler.errorClean(inputUsedCredit.closest(".textfield"));
    }
  }

  calculateAmount(htmlFc);

  //si llega hasta aqui es que todo esta bien con el valor usado en los credito
  // entonces se va a proceder a validar los creditos digitados vs lo que se va a pagar en el purchase
  return  VerifyTotalSentAmount(htmlFc);;

}

export function addAmountCredited(detail, htmlFc) {

  let inputAdd        =  detail.ev.target;
  let inputUsedCredit = inputAdd.closest('.line').querySelector('.used_credit input');
  //quitar error de input por si lo tiene
  textfieldHandler.errorClean(inputUsedCredit.closest(".textfield"));


  if (inputAdd.checked) {
    let inputCreditAvailable = inputAdd.closest('.line').querySelector('.available_credit input');
    let creditAvailable      = (inputCreditAvailable.value   == "" || parseFloat(inputCreditAvailable.value)   == NaN || 
                               parseFloat(inputCreditAvailable.value)   == 0) ? 0 : parseFloat(inputCreditAvailable.value);
    let UsedCredit           = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                               parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);

    if (UsedCredit < 1) {
      inputUsedCredit.value = parseFloat(inputCreditAvailable.value);
    }else{
      if (UsedCredit > creditAvailable ) {
        snackprovidercredit.start({ act: 'show', id: 'greaterUsedCredit'});
        textfieldHandler.error(inputUsedCredit.closest(".textfield"));
        return;
      }
    }
  } else {
    inputUsedCredit.value = 0;
  }




  calculateAmount(htmlFc);
  VerifyTotalSentAmount(htmlFc);


}

function calculateAmount(htmlFc) {
  
  let inputAmount = htmlFc.fullcontHTML.querySelector("#providercredit_form_amount input");
  inputAmount.value = getTotalCreditedToUse(htmlFc);

}

//busca el total del credited to use del mt Credited Purchases
function getTotalCreditedToUse(htmlFc) {
    // Inicializar el total
    let totalCreditToUse = 0;
    // Obtener todas las filas
    const lines = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_credited_purchase .line");
  
    lines.forEach((line) => {
      let inputAdd = line.querySelector(".add_credited_amount input");
  
      if (inputAdd.checked) {
        let inputUsedCredit = line.querySelector(".used_credit input");
        let usedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                              parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
  
        totalCreditToUse += usedCredit;
      }
  
  
    });

    return totalCreditToUse;
  
}

//busca el total del Paying Amount del mt Unpaid Purchases
function getTotalSentAmount(htmlFc) {
  // Inicializar el total
  let totalSentAmount = 0;

  // Obtener todas las filas
  const lines = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_paid_purchase .line");

  lines.forEach((line) => {
    let inputAdd = line.querySelector(".add_amount input");

    if (inputAdd.checked) {
      let inputSentAmount = line.querySelector(".sent_amount input");
      let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                            parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);

      totalSentAmount += SentAmount;
    }


  });

  return totalSentAmount;

}


export function addAmount(detail, htmlFc) {

  let inputAdd        = detail.ev.target;
  let inputSentAmount = inputAdd.closest('.line').querySelector('.sent_amount input');
  //quitar error de input por si lo tiene 
  textfieldHandler.errorClean(inputSentAmount.closest(".textfield"));

  if (inputAdd.checked) {
    let SentAmount = (inputSentAmount.value == "" || parseFloat(inputSentAmount.value) == NaN ||
                     parseFloat(inputSentAmount.value) == 0) ? 0 : parseFloat(inputSentAmount.value);

    if (SentAmount == 0) {
      let totalCreditToUse = getTotalCreditedToUse(htmlFc);
      let totalSentAmount  = getTotalSentAmount(htmlFc);

      if (totalCreditToUse > 0) {
        let inputDueAmount   = inputAdd.closest('.line').querySelector('.due_amount input');
        let dueAmount        = (inputDueAmount.value == "" || parseFloat(inputDueAmount.value) == NaN ||
                               parseFloat(inputDueAmount.value) == 0) ? 0 : parseFloat(inputDueAmount.value);

        //credito sin usar para colocar el purchase a pagar
        let creditAvailable = totalCreditToUse - totalSentAmount;
        if (creditAvailable > 0 ) {
          //si la cantidad que se debe es menor al credito a usar, se coloca la cantidad que se debe completa
          // de lo contrario se coloca el total de credito sin usar
          inputSentAmount.value = dueAmount < creditAvailable ? dueAmount : creditAvailable;
        }else{
          inputSentAmount.value = 0;
        }
      }

    }else{
      VerifyTotalSentAmount(htmlFc);
    }

  } else {
    inputSentAmount.value = 0;
  }

}

// verificar que el monto total a pagar del purchase no sea mayor al credito a pagar
function VerifyTotalSentAmount(htmlFc) {
  let totalCreditToUse  = getTotalCreditedToUse(htmlFc);
  let totalSentAmount   = getTotalSentAmount(htmlFc);
  const inputSentAmount = htmlFc.fullcontHTML.querySelectorAll("#providercredit_form_providercredit_vs_paid_purchase .sent_amount");

  if (totalSentAmount > totalCreditToUse) {
    inputSentAmount.forEach(input => {
      textfieldHandler.error(input);
    });
    snackprovidercredit.start({ act: 'show', id: 'insufficientCredit'});
    return false;
  }else{
    inputSentAmount.forEach(input => {
      textfieldHandler.errorClean(input);
    });
  }

  return true; 

}

export function keyValueSent(detail, htmlFc) {
  verifyValueSent(detail.ev.target, htmlFc);
}

//verificar que el monto a pagar del purchase no sea mayor a lo que se debe del purchase
export function verifyValueSent(input, htmlFc) {
  let inputSentAmount =  input;
  let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                              parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);

  if (SentAmount != 0) {
    let inputDueAmount  = inputSentAmount.closest('.line').querySelector('.due_amount input');
    let dueAmount       = (inputDueAmount.value   == "" || parseFloat(inputDueAmount.value)   == NaN || 
                          parseFloat(inputDueAmount.value)   == 0) ? 0 : parseFloat(inputDueAmount.value);

    if (SentAmount > dueAmount) {
      snackprovidercredit.start({ act: 'show', id: 'greaterSentAmount'});
      textfieldHandler.error(inputSentAmount.closest(".textfield"));
      return false;
    } else {
      textfieldHandler.errorClean(inputSentAmount.closest(".textfield"));
    }
  }

  //si llega hasta aqui es que todo esta bien con el valor usado en el pago del purchase
  // entonces se va a proceder a validar el total de lo pagado del purchase vs los creditos disponibles
  return VerifyTotalSentAmount(htmlFc);

}

